export default "__VITE_PUBLIC_ASSET__3bf7d715__"